<template>
  <div class="login">
    <home-header :isShow="false"></home-header>
    <div class="center_bg">

      <div class="login_left">
        <img src="../assets/images/login_bannerimg.png"/>
      </div>

      <div style="flex: 1;"></div>

      <div class="center">
        <div class="frombox">
          <div class="sjhForm">
            <el-form :model="formModel" :rules="rules" ref="form">
              <el-form-item prop="mobile">
                <div class="bingTitle">绑定手机号</div>
              </el-form-item>

              <el-form-item prop="mobile">
                <el-input
                  placeholder="请输入手机号"
                  v-model="formModel.mobile"
                  clearable
                >
                </el-input>
              </el-form-item>

              <el-form-item class="code" prop="code">
                <el-col :span="14">
                  <el-input
                    oninput="value=value.replace(/[^\d]/g,'')"
                    placeholder="请输入验证码"
                    v-model="formModel.code"
                    clearable
                  ></el-input>
                </el-col>
                <el-col :span="3">
                  <div>&nbsp;</div>
                </el-col>
                <el-col :span="7" class="code_box">
                  <el-button class="code_btn" style="width: auto;" type="button" @click="sendcode" :disabled="disabled"
                             v-if="disabled==false">发送验证码
                  </el-button>
                  <el-button class="code_btn" style="width: auto;" type="button" @click="sendcode" :disabled="disabled"
                             v-if="disabled==true">{{btntxt}}
                  </el-button>
                </el-col>
              </el-form-item>

            </el-form>

<!--            <div class="links">-->
<!--              <router-link to="/login">-->
<!--                <el-link :underline="false"><span style="color: #3370ff;">马上登录</span></el-link>-->
<!--              </router-link>-->
<!--            </div>-->

            <div class="dl" @click="changeData('form')">确认</div>
          </div>
        </div>
      </div>
    </div>
    <login-footer></login-footer>
  </div>

</template>


<script>
    // import HomeHeader from '@/components/Header'
    import HomeHeader from '@/components/homeHeader' 
    import LoginFooter from '@/components/LoginFooter'

    export default {
        name: "BindPhone",
        components: {
            HomeHeader,
            LoginFooter
        },
        data() {
            // 手机验证
            var validateMobilePhone = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("手机号不可为空"));
                } else {
                    if (value !== "") {
                        var reg = /^1[3456789]\d{9}$/;
                        if (!reg.test(value)) {
                            callback(new Error("请输入有效的手机号码"));
                        }
                    }
                    callback();
                }
            };
            // 密码验证
            var validatePass = (rule, value, callback) => {
                const pwdReg = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/;
                if (!value) {
                    return callback(new Error("请输入密码"));
                } else if (pwdReg.test(value)) {
                    callback();
                } else {
                    callback(new Error("请输入包含数字字母的不低于8位数的密码"));
                }
            };
            // 重复密码验证
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'))
                    // password 是表单上绑定的字段
                } else if (value !== this.formModel.password) {
                    callback(new Error('两次输入密码不一致!'))
                } else {
                    callback()
                }
            }
            return {
                disabled: false,
                time: 0,
                btntxt: "重新发送",
                formModel: {
                    mobile: "",
                    code: "",
                    group: "pc",
                    token: ""
                },
                rules: {
                    mobile: [
                        {
                            required: true,
                            validator: validateMobilePhone,
                            trigger: "change",
                        },
                    ],
                    code: [
                        {required: true, message: '请输入验证码'},
                    ]

                }
            };
        },
        created() {
            this.getToken()
        },
        methods: {
            getToken(){
                this.$data.formModel.token = this.$route.params.token
            },
            //手机验证发送验证码
            sendcode() {
                const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
                if (this.formModel.mobile == '') {
                    this.$message({
                        message: '手机号不能为空',
                        center: true
                    })
                    return
                }
                if (!reg.test(this.formModel.mobile)) {
                    this.$message({
                        message: '请输入正确的手机号',
                        center: true
                    })
                    return
                } else {
                    var data = {
                        mobile: this.formModel.mobile,
                        usage: 'up-mobile'
                    }
                    this.$api.sendCode(data).then(res => {
                        //数据处理
                        this.$message({
                            message: '发送成功',
                            type: 'success',
                            center: true
                        });
                        this.time = 60;
                        this.disabled = true;
                        this.timer();
                    }).catch(err => console.log(err))
                }
            },
            //60S倒计时
            timer() {
                if (this.time > 0) {
                    this.time--;
                    this.btntxt = this.time + "s后重新获取";
                    setTimeout(this.timer, 1000);
                } else {
                    this.time = 0;
                    this.btntxt = "获取验证码";
                    this.disabled = false;
                }
            },
            //完成
            changeData(form) {
                this.$refs[form].validate((valid) => {
                    console.log(valid)
                    if (valid) {
                        this.doReset()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //重置
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            doReset() {
                this.$api.bingphone(this.$data.formModel).then(res => {
                    //数据处理
                    this.$message.success('绑定成功')
                    localStorage.setItem('token',res.data.access_token)
                    localStorage.setItem('user',JSON.stringify(res.data.member))
                    this.$router.replace({
                        path: '/'
                    });
                }).catch(err => console.log(err))
            },
        }
    };
</script>

<style scoped>
  .login {
    width: 100%;
    position: relative;
  }

  .center_bg {
    width: 100%;
    height: 510px;
    background: #6BC96B;
    background-size: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0px 400px;
    box-sizing: border-box;

  }

  .bingTitle {
    width: 100%;
    text-align: center;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #3370ff;
    margin-bottom: 10px;
  }

  .title {
    text-align: center;
  }

  .title div {
    height: 40px;
    font-size: 40px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 20px;
  }

  .title span {
    width: 153px;
    height: 14px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }

  .frombox {
    width: 400px;
    height: 450px;
    background: #ffffff;
    border-radius: 10px;
    padding: 15px 0px 20px 0px;
    box-sizing: border-box;
  }

  .sjhForm {
    margin-top: 40px;
  }

  .el-menu--horizontal > .el-menu-item.is-active {
    background: #3370ff !important;
    color: #ffffff !important;
    border-bottom: none;
  }

  .el-button:focus, .el-button:hover {
    background: none !important;
  }

  .btns {
    width: 300px;
    height: 40px;
    background: #f6f6f6;
    border-radius: 20px;
    margin: 0px auto;
    display: flex;
  }

  .el-button {
    height: 40px;
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    background: none;
    border: none;
    color: #999999;
    border: 1px solid #EEEEEE;
  }

  .el-button + .el-button {
    margin: 0px !important;
  }

  .el-link {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
  }

  .el-form,
  .links {
    width: 300px;
    margin: 10px auto;
  }

  .el-form-item {
    margin-bottom: 30px;
  }

  .frombox >>> .el-input__inner {
    border-top: none;
    border-bottom: 1px solid #eeeeee;
    border-left: none;
    border-right: none;
  }

  .dl {
    width: 300px;
    height: 40px;
    background: #3370ff;
    border-radius: 20px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    margin: 40px auto 0px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .ewm {
    text-align: center;
    margin-top: 25px;
  }

  .login_left img {
    width: 350px;
  }

  .code_box {

  }
</style>



// WEBPACK FOOTER //
// src/bindphone/phone.vue